import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MainContent, YOUTUBE_THUMBNAIL } from './core/simple-gallery.model';
const defaultThumbPath = '../../../../../assets/medias/images/thumb-video.png';

@Injectable({
  providedIn: 'root',
})
export class SimpleGalleryService {
  protected mainContent$ = new BehaviorSubject<MainContent | undefined>(undefined);

  getContent() {
    return this.mainContent$.asObservable();
  }

  setContent(content: MainContent) {
    this.mainContent$.next(content);
  }

  getThumbVideo(videoUrl: string, thumbSize: YOUTUBE_THUMBNAIL): string {
    if (videoUrl.includes('.youtube')) {
      const videoID = videoUrl.split('embed/')[1].split('?')[0];
      return `https://img.youtube.com/vi/${videoID}/${thumbSize}`;
    }

    return defaultThumbPath;
  }
}
